import React, { useEffect, useRef } from 'react';
import CommentItem from './CommentItem';
import { ITripComment } from '../../Models/trips/trip-comment.model';

interface CommentHistoryProps {
  comments: ITripComment[];
  currentUserId: string;
  onDelete: (commentId: string) => void;
  loading?: boolean;
}

const CommentHistory: React.FC<CommentHistoryProps> = ({
  comments,
  currentUserId,
  onDelete,
  loading = false
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const prevCommentCountRef = useRef<number>(comments.length);

  // Auto-scroll to bottom when new comments are added
  useEffect(() => {
    if (
      comments.length > prevCommentCountRef.current &&
      scrollContainerRef.current
    ) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
    prevCommentCountRef.current = comments.length;
  }, [comments.length]);

  if (loading) {
    return (
      <div className='comment-history comment-history--loading'>
        <div className='comment-history__spinner'>Loading comments...</div>
      </div>
    );
  }

  if (comments.length === 0) {
    return (
      <div className='comment-history comment-history--empty'>
        <div className='comment-history__empty-message'>
          No comments yet. Be the first to comment!
        </div>
      </div>
    );
  }

  return (
    <div
      className='comment-history'
      ref={scrollContainerRef}
    >
      <div className='comment-history__list'>
        {comments.map((comment) => {
          const isOwn = comment.userId.toString() === currentUserId;
          return (
            <div
              key={comment.id}
              className={`comment-wrapper ${isOwn ? 'comment-wrapper--own' : 'comment-wrapper--other'}`}
            >
              <CommentItem
                comment={comment}
                currentUserId={currentUserId}
                onDelete={onDelete}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommentHistory;
